import React from "react";
import RailsFormGenericInput from "./RailsFormGenericInput";

/**
 * props should include
 * model name
 * attribute name
 * numberType
 * label
 * value
 * onChangeEvent
 */
export default class RailsFormTextInput extends RailsFormGenericInput{
  getLabelWidth(){
    if (!!this.props.labelWidth 
      && isNaN(this.props.labelWidth) === false 
      && this.props.labelWidth >= 1
      && this.props.labelWidth <= 6){
      return this.props.labelWidth;
    }else{
      return 3;
    }
  }

  render(){
    const inputType = ((this.props && this.props.numberType && this.props.numberType === true) ? "number" : "text");
    const formControlClass = !!this.props.readonly ? "form-control-plaintext" : "form-control" ;
    const labelColWidth = this.getLabelWidth(),
      inputColWidth = 12 - labelColWidth,
      labelColClass = `col-md-${labelColWidth}`,
      inputColClass = `col-md-${inputColWidth}`;
    return (
      <div className="form-group row">
        <label className={`${labelColClass} col-form-label`}>{this.props.label ? this.props.label : this.props.attribute_name }</label>
        <input 
          className={`${formControlClass} ${inputColClass}`}
          type={inputType}
          name={`${this.props.model_name}[${this.props.attribute_name}]`}
          id={`${this.props.model_name}_${this.props.attribute_name}`}
          value={this.props.value}
          disabled={this.props.disabled === true}
          readOnly={this.props.readonly === true}
          onChange={ this.onValueChange }
        />
      </div>
    );
  }
}